import React from 'react';
import GameAddEdit from '../../../components/admin/GameAddEdit/GameAddEdit';
import styles from './AdminSupportCreate.module.scss';
import SupportAddEdit from '../../../components/admin/SupportAddEdit/SupportAddEdit';
const AdminSupportCreate = () => {
  return <SupportAddEdit />;
};

export default AdminSupportCreate;
